
export function getSequenceVersionFile()
{
    return 2;
}

export function createV2SequencesFiles (v1file)
{
    var version = 1;
    const actualversion = getSequenceVersionFile();
    if ("version" in v1file) version = v1file.version;


    if (version === 1)
    {
        var newfile = {};
        if ("pjid" in v1file) newfile.pjid = v1file.pjid;
        newfile.version = actualversion;
        newfile.sequences = [];
        const defaultSource = "IA";
        if ("sequences" in v1file)
        {
            v1file.sequences.forEach(element => {

                var newelement = sequencesCreateDefaultSequenceV2(element.in, element.out);

                // emotion

                newelement.current.emotions[0].type = element.emotion.toUpperCase();
                newelement.ia.emotions[0].type = element.emotion.toUpperCase();
                
                newelement.current.emotions[0].source = defaultSource;
                newelement.ia.emotions[0].source = defaultSource;
                newelement.current.emotions[0].confidence = 0.5;
                newelement.ia.emotions[0].confidence = 0.5;

                // titre



                if (element.description) newelement.current.descriptionA = element.description;
                if (element.description) newelement.current.descriptionB = element.description;

                newelement.current.sourceA = defaultSource;
                newelement.current.sourceB = defaultSource;


                if (element.description) newelement.ia.descriptionA = element.description;
                if (element.description) newelement.ia.descriptionB = element.description;

                newelement.ia.sourceA = defaultSource;
                newelement.ia.sourceB = defaultSource;

                newelement.title = element.title;

                // subjects

                if ("subjects" in element)
                {
                    element.subjects.forEach( subject =>{

                        newelement.current.thematics.push ({iptccode: subject.code,source:defaultSource, confidence:0.5});
                        newelement.ia.thematics.push ({iptccode: subject.code,source:defaultSource, confidence:0.5});
                    })
                }
                newfile.sequences.push(newelement);

            });
        }
        return newfile;

    }

    return v1file;
}

export function sequencesCreateDefaultSequenceV2(tcin, tcout)
{
    return {
        in: tcin,
        duration: tcout - tcin,
        out: tcout,
        title: "No Title",

        real_place:"",
        fictional_place:"",
        real_epoch:"",
        fictional_epoch:"",

        current:
        {

            descriptionA: "",
            descriptionB: "",
            sourceA: "HUMAN",
            sourceB: "HUMAN",

            emotions: [
                {
                    type:"NEUTRAL",
                    source:"HUMAN",
                    intensity: 0.5,
                    sentiment: 0,
                    confidence: 1,
                }
            ],
            thematics: [
                /* {iptccode:"", source:"HUMAN*, confidence: 1 */
            ]
        },

        ia:
        {
            descriptionA: "",
            descriptionB: "",
            sourceA: "HUMAN",
            sourceB: "HUMAN",


            emotions: [
                {
                    type:"NEUTRAL",
                    source:"HUMAN",
                    intensity: 0.5,
                    sentiment: 0,
                    confidence: 1,
                }
            ],
            thematics: [
                /* {iptccode:"", type:"HUMAN*, confidence: 1 */
            ]
        },
        corrections: [],


    }

}


export function sequencesGetEmotionsList(language)
{
    return [
        {
            emotion: "NEUTRAL",
            text: language==="fr"?"Neutre":"Neutral"
        },
        {
            emotion: "JOY",
            text: language==="fr"?"Joie":"JOY"
        },
        {
            emotion: "SADNESS",
            text: language==="fr"?"Tristesse":"Sadness"
        },
        {
            emotion: "ANGER",
            text: language==="fr"?"Colère":"Anger"
        },
        {
            emotion: "FEAR",
            text: language==="fr"?"Peur":"Fear"
        },
        {
            emotion: "DISGUST",
            text: language==="fr"?"Dégoût":"Disgust"
        },
        {
            emotion: "SURPRISE",
            text: language==="fr"?"Surprise":"Surprise"
        }
    ]
}



